const DEFAULT_CORE_GROUP_WORKFLOW_STATUS = 'draft';

const CORE_GROUP_WORKFLOW_STATUSES = Object.freeze([
  Object.freeze({
    id: 'draft',
    labelKey: 'sidebar_rechts.gruppenstatus.wert.entwurf',
    fallbackLabel: 'Entwurf'
  }),
  Object.freeze({
    id: 'quote',
    labelKey: 'sidebar_rechts.gruppenstatus.wert.offerte',
    fallbackLabel: 'Offerte'
  }),
  Object.freeze({
    id: 'ordered',
    labelKey: 'sidebar_rechts.gruppenstatus.wert.bestellung',
    fallbackLabel: 'Bestellung'
  }),
  Object.freeze({
    id: 'execution',
    labelKey: 'sidebar_rechts.gruppenstatus.wert.ausfuehrung',
    fallbackLabel: 'Ausführung'
  }),
  Object.freeze({
    id: 'completed',
    labelKey: 'sidebar_rechts.gruppenstatus.wert.abgeschlossen',
    fallbackLabel: 'Abgeschlossen'
  })
]);

const CORE_GROUP_WORKFLOW_STATUS_IDS = new Set(
  CORE_GROUP_WORKFLOW_STATUSES.map(status => status.id)
);

function normalizedStatusId(value) {
  return String(value ?? '').trim().toLowerCase();
}

function isCoreGroupWorkflowStatus(value) {
  return CORE_GROUP_WORKFLOW_STATUS_IDS.has(normalizedStatusId(value));
}

function normalizeCoreGroupWorkflowStatus(value, fallback = DEFAULT_CORE_GROUP_WORKFLOW_STATUS) {
  const candidate = normalizedStatusId(value);
  if (CORE_GROUP_WORKFLOW_STATUS_IDS.has(candidate)) return candidate;
  const normalizedFallback = normalizedStatusId(fallback);
  return CORE_GROUP_WORKFLOW_STATUS_IDS.has(normalizedFallback)
    ? normalizedFallback
    : DEFAULT_CORE_GROUP_WORKFLOW_STATUS;
}

function coreGroupWorkflowStatusDefinition(value) {
  const normalized = normalizeCoreGroupWorkflowStatus(value);
  return CORE_GROUP_WORKFLOW_STATUSES.find(status => status.id === normalized)
    || CORE_GROUP_WORKFLOW_STATUSES[0];
}

export {
  CORE_GROUP_WORKFLOW_STATUSES,
  DEFAULT_CORE_GROUP_WORKFLOW_STATUS,
  coreGroupWorkflowStatusDefinition,
  isCoreGroupWorkflowStatus,
  normalizeCoreGroupWorkflowStatus
};
